<template>
    <section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-lg-6 col-xl-8 offset-lg-3 offset-xl-2 py-7 py-lg-9 px-lg-7">

                    <!-- Heading -->
                    <h1 class="mb-6">Changelog</h1>

                    <!-- Text -->
                    <p class="text-gray-700" id="v19.05.2">
                        <span class="badge badge-pill badge-success-soft">v19.05.2</span>
                        <span>- May 20th, 2019</span>
                    </p>

                    <!-- List -->
                    <ul class="text-gray-700">
                        <li>New edition of AcreCX,  AcreCX Express, implemented.</li>
                        <li>Tax configuration and addition feature for each organization implemented.</li>
                        <li>Event History, all activities in the AcreCX platform, implemented.</li>
                    </ul>

                    <!-- Text -->
                    <p class="text-gray-700" id="v19.04.1">
                        <span class="badge badge-pill badge-success-soft">v19.04.1</span>
                        <span>- April 21st, 2019</span>
                    </p>

                    <!-- List -->
                    <ul class="text-gray-700">
                        <li>Feature for flexibility to create sale order and invoice in any currency added.</li>
                        <li>Internationalization feature added.</li>
                        <li>TruVito audits can be accessed from the application.</li>
                    </ul>


                    <!-- Text -->
                    <p class="text-gray-700" id="v19.03.2">
                        <span class="badge badge-pill badge-success-soft">v19.03.2</span>
                        <span>- April 2nd, 2019</span>
                    </p>

                    <ul class="text-gray-700">
                        <li>Forward and Spot contracts are implemented.</li>
                        <li>AcreCX implements USD as the native currency of the application.</li>
                        <li>Integration with TruVito implemented.</li>
                        <li>Inventory Management feature modified.</li>
                        <li>Excel template based customer on-boarding implemented.</li>
                    </ul>


                    <!-- Text -->
                    <p class="text-gray-700" id="v19.03.1">
                        <span class="badge badge-pill badge-success-soft">v19.03.1</span>
                        <span>- March 20th, 2019</span>
                    </p>

                    <!-- List -->
                    <ul class="text-gray-700">
                        <li>Inventory Management feature added.</li>
                        <li>Smart contract for purchase order, sale orders and invoice added.</li>
                        <li>Subscription plans for customer added.</li>
                        <li>Faceted search feature for offers added.</li>
                    </ul>

                    <!-- Text -->
                    <p class="text-gray-700" id="v19.03.0">
                        <span class="badge badge-pill badge-success-soft">v19.03.0</span>
                        <span>- March 1st, 2019</span>
                    </p>

                    <!-- List -->
                    <ul class="text-gray-700">
                        <li>Initial release of AcreCX!</li>
                    </ul>

                </div>
                <div class="col-12 col-lg-3 col-xl-2 d-none d-lg-block px-lg-0 sidenav sidenav-right">
                    <div class="my-7 my-lg-9 px-lg-7 border-left-lg border-gray-300">

                        <!-- Heading -->
                        <h6 class="text-uppercase font-weight-bold">
                            Jump to
                        </h6>

                        <!-- Links -->
                        <ul class="list mb-0">
                            <li class="list-item">
                                <a class="list-link" href="#v19.05.2" data-toggle="smooth-scroll">v19.05.2</a>
                            </li>
                            <li class="list-item">
                                <a class="list-link" href="#v19.04.1" data-toggle="smooth-scroll">v19.04.1</a>
                            </li>
                            <li class="list-item">
                                <a class="list-link" href="#v19.03.2" data-toggle="smooth-scroll">v19.03.2</a>
                            </li>
                            <li class="list-item">
                                <a class="list-link" href="#v19.03.1" data-toggle="smooth-scroll">v19.03.1</a>
                            </li>
                            <li class="list-item">
                                <a class="list-link" href="#v19.03.0" data-toggle="smooth-scroll">v19.03.0</a>
                            </li>
                        </ul>

                    </div>
                </div>
            </div> <!-- / .row -->
        </div>
    </section>
</template>

<script>
    export default {
        name: "ChangeLog"
    }
</script>

<style scoped>
    .sidenav-right {
        position: absolute;
    }
</style>